import { AQI_CATEGORIES } from '../config/constants';

/**
 * Get the AQI category object based on AQI value
 * @param {number} aqi - The AQI value
 * @returns {object} The category object containing label, color, and textColor
 */
export const getAQICategory = (aqi) => {
    if (aqi === undefined || aqi === null || aqi < 0 || aqi === '-') {
        return { label: 'Unknown', color: '#999999', textColor: '#ffffff' };
    }

    const numericAqi = Number(aqi);
    if (isNaN(numericAqi)) {
        return { label: 'Unknown', color: '#999999', textColor: '#ffffff' };
    }

    return AQI_CATEGORIES.find(cat => numericAqi <= cat.max) || AQI_CATEGORIES[AQI_CATEGORIES.length - 1];
};

/**
 * Get the color for an AQI value
 * @param {number} aqi - The AQI value
 * @returns {string} Hex color code
 */
export const getAQIColor = (aqi) => {
    return getAQICategory(aqi).color;
};

/**
 * Get the contrasting text color for an AQI value
 * @param {number} aqi - The AQI value
 * @returns {string} Hex color code for text
 */
export const getAQITextColor = (aqi) => {
    return getAQICategory(aqi).textColor;
};

/**
 * Get the label for an AQI value
 * @param {number} aqi - The AQI value
 * @returns {string} Category label
 */
export const getAQILabel = (aqi) => {
    return getAQICategory(aqi).label;
};

/**
 * Format AQI value for display
 * @param {number|string} aqi - The AQI value
 * @returns {string} Formatted AQI value
 */
export const formatAQI = (aqi) => {
    if (aqi === undefined || aqi === null || aqi === '-') {
        return '-';
    }
    const numericAqi = Number(aqi);
    if (isNaN(numericAqi)) {
        return '-';
    }
    return Math.round(numericAqi).toString();
};
